import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import {
  AUTOCOMPLETE_PAGE_SIZE,
  PageRequestParams,
} from '../../common/queryClient';
import {
  PermissionOptionsPageSchema,
  PermissionPageSchema,
} from '../schema/PermissionSchema';
import { PermissionUrl } from './PermissionUrl';
import { PermissionDto } from '../schema';
import { QueryFunctionContext } from '@tanstack/react-query';
import { useInfiniteSearchQuery } from '../../common/queryClient/useInfiniteSearchQuery';

const getPermissions = (params: { name: string } & PageRequestParams) =>
  apiClient
    .get<PermissionDto>(expand(PermissionUrl.SEARCH, params))
    .then((response) => PermissionPageSchema.parse(response.data));

export const usePermissionsQuery = createApiQueryHook(
  ['permissions'],
  getPermissions,
);

const searchPermissionOptions = ({
  meta,
  pageParam,
}: QueryFunctionContext<any, number>) =>
  apiClient
    .get<PermissionDto>(
      expand(PermissionUrl.SEARCH, {
        ...meta,
        name: (meta?.searchText ?? '') as string,
        page: pageParam ?? 0,
        size: AUTOCOMPLETE_PAGE_SIZE,
      }),
    )
    .then((response) => PermissionOptionsPageSchema.parse(response.data));

export const useInfiniteSearchPermissionsQuery = (
  term: string,
  searchOptions?: { excludeIds?: number[] },
) =>
  useInfiniteSearchQuery(
    ['permissions-autocomplete'],
    searchPermissionOptions,
    term,
    searchOptions,
  );
